// extracted by mini-css-extract-plugin
module.exports = {"nav":"Header_nav__SKrI9","logo":"Header_logo__3nkIa"};